import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';
import { NgGridStackWidget } from 'gridstack/dist/angular';

@Component({
    selector: 'tt-my-page',
    templateUrl: './my-page.component.html',
    styleUrls: ['./my-page.component.css'],
})
export class MyPageComponent {
    /**
     * The name of the my page webpagemenu to load into generic webpagemnu component.
     */
    public webpageName = '';

    public customWidgets: NgGridStackWidget[] = [{ id: 'mypagecustomwidget', sizeToContent: true, w: 4, selector: 'tt-my-page-custom-widget' }];

    constructor(private state: StateService) {
        this.webpageName = this.state.getCurrentName();
    }
}
